import React, { useEffect, useState, useCallback } from "react";
import Swal from "sweetalert2";
import { HelpHttp } from "helpers/HelpHttp";
import { HelpFunctions } from "helpers/HelpFunctions";
import { trackPromise } from "react-promise-tracker";
import axios from "axios";

const { REACT_APP_API } = process.env;

const PortabilidadNip = ({ service }) => {
    console.log("PortabilidadNip")
    const [parameters, setParameters] = useState([]);
    const [success, setSuccess] = useState("");
    const [timeout, setTimeout] = useState("")
    const [codError, setCodError] = useState("");
    const [trama, setTrama] = useState({});

    let api = HelpHttp();
    let f = HelpFunctions();

    const urlTrama = `${REACT_APP_API}/parameters/findTrama`;
    const url = `${REACT_APP_API}/parameters/findAllByService/${service.code}`;

    const getParameters = async () => {
        trackPromise(
            api.get(url).then((res) => {
                console.log("url: ", url);
                if (res.err) {
                    setParameters(null);
                } else {
                    setParameters(res);
                    console.log("serviceParemetersCapacityH: ", res);
                    res.forEach((element) =>
                        element.parameter === "success"
                            ? setSuccess(element.value)
                            : setTimeout(element.value)
                    );
                }
            })
        );
    };

    async function updateParameters() {
        let data1 = {};
        let data2 = {};
        let error = false; // Inicializa error como falso

        // Validar si los parámetros están vacíos
        if (!parameters.length) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "No hay parámetros disponibles.",
            });
            return null;
        }

        console.log("parameters: ", parameters);

        // Validar cada parámetro
        // Validar cada parámetro
        parameters.forEach((param) => {
            if (param.parameter === "success") {
                data1.service = service.code;
                data1.parameter = "success";
                data1.value = success;

                if (!success) {
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "El valor de success no puede estar vacío.",
                    });
                    error = true;
                } else if (success === "false" && (!codError || codError === '200' || codError === '201')) {
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Por favor, seleccione un tipo de error!",
                    });
                    error = true;
                } else if (success === "true" && (!codError || (codError !== '200' && codError !== '201'))) {
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Por favor, seleccione un tipo de éxito!",
                    });
                    error = true;
                } else {
                    data1.cod_error = codError;
                }
            } else if (param.parameter === "timeout") {
                data2.service = service.code;
                data2.parameter = "timeout";
                data2.value = timeout;

                if (!timeout) {
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "El valor de timeout no puede estar vacío.",
                    });
                    error = true;
                }
            }
        });

        if (error) return null;

        try {
            const resp1 = await f.updateParam(data1);
            if (resp1.success) {
                const resp2 = await f.updateParam(data2);
                if (resp2.success) {
                    Swal.fire("Ok", "¡Datos actualizados!", "success");
                    await getParameters();
                } else {
                    Swal.fire("¡Ok!", `${resp2.message}!`, "warning");
                }
            } else {
                Swal.fire("Ok", `${resp1.message}!`, "warning");
            }
        } catch (err) {
            console.error(err);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Ocurrió un error al actualizar los parámetros.",
            });
        }
    }


    const getTrama = useCallback(async (url) => {
        let { data } = await axios.post(url, parameters);
        console.log({ data });
        setTrama(data);
    }, [parameters]);

    useEffect(() => {
        getParameters();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!parameters.length) return;

        const parameterSuccess = parameters.find(
            (param) => param.parameter === "success" && (param.value === "false" || param.value === "true")
        );

        if (parameterSuccess) {
            setCodError(parameterSuccess.cod_error);
        }

        console.log("Obteniendo trama");
        getTrama(urlTrama);
    }, [parameters, getTrama, urlTrama]);


    return (
        <>
            {parameters &&
                <div className="card ">
                    <h5 className="card-header">{service.name} <small style={{ fontWeight: "normal" }} className="text-muted">{service.endpoint || "Sin Ruta"}</small></h5>
                    <div className="card-body">
                        <p className="card-text">{service.description}</p>
                        <fieldset className="row mb-3">
                            <legend className="col-form-label col-sm-3 pt-0">Parámetro Success:</legend>
                            <div className="col-sm-9">
                                <div className="form-check">
                                    <div className="row">
                                        <div className="col-sm-2">
                                            <input type="radio" className="form-check-input" id="rad_Success_true"
                                                checked={success === 'true'} name="radioSuccess" value="true"
                                                onChange={(e) => setSuccess(e.target.value)} />
                                            <label htmlFor="rad_Success_true"
                                                className="form-check-label">True</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-check">
                                    <div className="row">
                                        <div className="col-sm-3">
                                            <input type="radio" className="form-check-input" id="rad_Success_false"
                                                checked={success === 'false'} name="radioSuccess" value="false"
                                                onChange={(e) => setSuccess(e.target.value)} />
                                            <label htmlFor="rad_Success_false"
                                                className="form-check-label">False</label>
                                        </div>
                                        {success === 'false' &&
                                            <>
                                                <div className="col-sm-6">
                                                    <div className="mb-2">
                                                        <label htmlFor="codError">Tipo de Error</label>
                                                        <select className="form-select form-select-sm"
                                                            onChange={(e) => setCodError(e.target.value)} name="codError" id="codError" value={codError}>
                                                            <option value="">Seleccione...</option>
                                                            {/*Solicitud*/}
                                                            <option value="400">(Status 201) Solicitud exitosa para algunas líneas móviles</option>
                                                            <option value="401">(Status 201) Solicitud Error Inestabilidad del Legado</option>
                                                            <option value="407">(Status 201) Solicitud Canal incorrecto</option>
                                                            <option value="408">(Status 201) Solicitud Tipo de operación no soportada</option>
                                                            <option value="409">(Status 201) Solicitud Error Tipo de usuario no soportado</option>
                                                            <option value="402">(Status 400) Solicitud Error Validación de Campos</option>
                                                            <option value="406">(Status 500) Solicitud Error del Microservicio</option>
                                                            <option value="410">(status 600) - Error status no validado anteriormente</option>
                                                            {/*Reenvio*/}
                                                            <option value="404">(Status 201) Reenvío exitosa para algunas líneas móviles</option>
                                                            <option value="405">(Status 201) Reenvío Error Inestabilidad del Legado</option>
                                                            <option value="407">(Status 201) Reenvio Canal incorrecto</option>
                                                            <option value="408">(Status 201) Reenvio Tipo de operación no soportada</option>
                                                            <option value="409">(Status 201) Reenvio Error Tipo de usuario no soportado</option>
                                                            <option value="403">(Status 400) Reenvio Error Validación de Campos</option>
                                                            <option value="406">(Status 500) Reenvio Error del Microservicio</option>
                                                            <option value="410">(status 600) - Error status no validado anteriormente</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {success === 'true' &&
                                            <>
                                                <div className="col-sm-6">
                                                    <div className="mb-2">
                                                        <label htmlFor="codSucess">Tipo de Success</label>
                                                        <select className="form-select form-select-sm"
                                                            onChange={(e) => setCodError(e.target.value)} name="codError" id="codError" value={codError}>
                                                            <option value="">Seleccione...</option>
                                                            <option value="200">(status 200) - Solicitud Exitosa de NIP</option>
                                                            <option value="201">(status 200) - Reenvio Exitoso de NIP</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset className="row mb-3">
                            <legend className="col-form-label col-sm-3 pt-0">Parámetro Timeout:</legend>
                            <div className="col-sm-9">
                                <div className="form-check">
                                    <input type="radio" className="form-check-input" id="rad_TimeOut_true"
                                        checked={timeout === 'true'} name="radioTimeOut" value="true"
                                        onChange={(e) => setTimeout(e.target.value)} />
                                    <label htmlFor="rad_TimeOut_true">True</label><br />
                                </div>
                                <div className="form-check">
                                    <input type="radio" className="form-check-input" id="rad_TimeOut_false"
                                        checked={timeout === 'false'} name="radioTimeOut" value="false"
                                        onChange={(e) => setTimeout(e.target.value)} />
                                    <label htmlFor="rad_TimeOut_false">False</label><br />
                                </div>
                            </div>
                        </fieldset>
                        <button type="submit" className="btn btn-primary"
                            onClick={updateParameters}><i className="bi bi-save2" /> Actualizar
                        </button>
                    </div>
                    <div className="card bg-light mt-2" id="trama">
                        <div className="card-body">
                            <h6>Request:</h6>
                            <pre>
                                <code>{JSON.stringify(trama.request, null, 2)}</code>
                            </pre>
                        </div>
                    </div>
                    <div className="card bg-light mt-2" id="trama">
                        <div className="card-body">
                            <h6>Response:</h6>
                            <pre>
                                <code>{JSON.stringify(trama.content, null, 2)}</code>
                            </pre>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default PortabilidadNip;